import BranchEnum from '@/modules/core/models/BranchEnum'
import { useHealthStore as useOldHealthStore } from '@/modules/core/stores/healthStore'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { useHealthStore } from '@/modules/health/rater/stores'
import ModifyInsuranceModal from '@/modules/health/rater/views/modals/ModifyInsuranceModal.vue'
import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { raterGuard as pymesRaterGuard } from '../guards'

const RATER_TITLE = 'Precios y Tarifas de los Seguros de Pymes | ASISA'
const RATER_DESCRIPTION =
  'El mejor precio en tu seguro de pymes ASISA con nuestro tarificador. Compara tarifas y encuentra la opción que mejor se adapte a ti.'

export const PYMES_HEALTH_RATER_ROUTES: RouteRecordRaw[] = [
  {
    path: 'salud',
    // name: 'rater-pymes-health',
    name: 'rater-health',
    component: () => import('@/modules/common/rater/views/BaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.HEALTH,
      defaultBusinessLineId: 'AS02'
    },
    props: () => ({
      store: useHealthStore()
    }),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing-almost-got-it')
      pymesRaterGuard(to, from, next)
    }
  },
  {
    path: 'salud/:productCode/:clientCode',
    name: 'pymes-health-product',
    component: () => import('@/modules/common/rater/views/ProductBaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.HEALTH,
      defaultBusinessLineId: 'AS02'
    },
    props: () => ({
      store: useHealthStore(),
      modifyModal: ModifyInsuranceModal,
      omitStopLoading: true
    }),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      pymesRaterGuard(to, from, next)
    }
  },
  {
    path: 'salud/propuestas',
    name: 'pymes-health-insurance-proposals',
    component: () => import('@/modules/common/rater/views/ProductProposalsView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.HEALTH,
      isPymes: true
    },
    props: () => ({
      store: useHealthStore(),
      oldStore: useOldHealthStore(),
      modifyModal: ModifyInsuranceModal
    }),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      pymesRaterGuard(to, from, next)
    }
  }
]
